import { MetaReducer } from '@ngrx/store';
import { appActions } from './app.actions';
import { DEVICE_FEATURE_KEY } from './device/keys';
import { ICON_FEATURE_KEY } from './icon/keys';
import { UPDATE_FEATURE_KEY } from './update/keys';

// Root meta-reducer: on App/Reset, reinitialise every feature slice in one shot — scales to any
// number of stores with no per-store wiring. Three user-independent slices are preserved:
// `device` owns the lock overlay, which must stay up across a user switch until the new user's
// data has loaded; `update` holds a downloaded OTA bundle, which would otherwise be orphaned on
// logout/user-switch and re-downloaded from scratch; `icon` caches immutable static SVGs shared
// by every user, which would otherwise be re-fetched after each shift change.
export const clearState: MetaReducer<Record<string, unknown>> = (reducer) => {
    return (state, action) => {
        if (action.type === appActions.reset.type && state) {
            return reducer(
                {
                    [DEVICE_FEATURE_KEY]: state[DEVICE_FEATURE_KEY],
                    [ICON_FEATURE_KEY]: state[ICON_FEATURE_KEY],
                    [UPDATE_FEATURE_KEY]: state[UPDATE_FEATURE_KEY],
                },
                action,
            );
        }
        return reducer(state, action);
    };
};
